var _rect, _path, _path2, _path3, _path4, _line, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2, _path19, _rect3, _path20, _ellipse, _path21, _path22, _path23, _g, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 252,
    viewBox: "0 0 241 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15629,
    height: 9848,
    transform: "translate(-6656 -1045)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1069 66.6498C50.0727 73.715 49.5914 82.3696 52.8649 90.5234C56.1539 98.716 63.1741 106.252 75.8507 111.129C78.5337 112.162 81.4657 110.843 82.6608 108.322L85.4616 102.413C87.4419 98.236 84.9292 93.4989 80.6694 92.216C74.2042 90.2688 70.3417 87.7627 68.4848 83.6758C66.5872 79.4991 66.628 73.3588 68.8821 63.737C69.3629 61.6848 69.0568 59.4959 68.0304 57.8601C66.9702 56.1705 65.1218 55.0776 62.7757 55.4808C60.819 55.817 58.6912 56.6605 56.7697 58.4328C54.8513 60.2024 53.2048 62.8366 52.1069 66.6498Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4382
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.867 137.517C201.711 176.846 173.391 214.634 131.595 221.907C89.7987 229.18 50.3787 203.18 43.5349 163.852C36.6911 124.524 65.011 86.7355 106.807 79.4623C148.603 72.189 188.023 98.1891 194.867 137.517Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.873 116.511C176.474 112.056 193.95 88.8627 189.725 64.5845C185.5 40.3062 161.217 24.3795 135.616 28.8346C110.014 33.2897 92.5387 56.4831 96.7635 80.7613C100.988 105.04 125.271 120.966 150.873 116.511Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4382
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.266 36.4969C119.97 27.1427 129.224 21.817 139.365 19.7635C150.158 17.5781 161.809 19.1406 170.84 23.4082C179.735 27.6118 187.468 36.3312 191.531 46.7309C195.351 56.5089 195.858 67.5889 191.218 77.6003L114.266 36.4969Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4.05188
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 188.019,
    y1: 75.8888,
    x2: 222.034,
    y2: 94.0575,
    stroke: "black",
    strokeWidth: 4.05188
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.581 174.227C142.381 181.324 132.526 182.37 124.393 180.233C116.256 178.096 109.829 172.768 105.499 167.093C103.21 164.093 102.195 161.427 101.949 159.122C101.703 156.818 102.224 154.865 103.022 153.288C103.82 151.712 105.243 151.1 106.763 151.219C108.29 151.339 109.912 152.198 111.071 153.568C117.48 161.147 122.634 165.152 127.584 166.218C132.543 167.287 137.265 165.4 142.787 161.292C145.776 159.068 150.104 159.805 151.847 163.078L154.921 168.848C155.925 170.733 155.378 173.088 153.581 174.227Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.24382
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.64 85.5173C119.223 88.9388 106.402 81.3947 101.236 73.7549C110.029 112.193 131.437 95.8458 131.437 95.8458C133.873 98.8202 135.914 99.822 138.927 100.483C138.927 100.483 132.503 96.2816 131.312 89.4337C130.12 82.5857 134.851 77.0623 134.851 77.0623C131.429 79.4398 130.435 81.3071 129.64 85.5173Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.385 57.0081C116.858 59.7278 115.091 62.3067 112.438 62.7685C109.785 63.2302 107.25 61.3998 106.777 58.6802C106.304 55.9605 108.071 53.3816 110.724 52.9198C113.377 52.4581 115.912 54.2885 116.385 57.0081Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.385 57.0081C116.858 59.7278 115.091 62.3067 112.438 62.7685C109.785 63.2302 107.25 61.3998 106.777 58.6802C106.304 55.9605 108.071 53.3816 110.724 52.9198C113.377 52.4581 115.912 54.2885 116.385 57.0081Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.385 57.0081C116.858 59.7278 115.091 62.3067 112.438 62.7685C109.785 63.2302 107.25 61.3998 106.777 58.6802C106.304 55.9605 108.071 53.3816 110.724 52.9198C113.377 52.4581 115.912 54.2885 116.385 57.0081Z",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.428 96.1484C124.725 97.0855 119.914 98.592 114.582 95.6839C112.428 94.0677 110.07 92.5101 109.611 89.8676C114.54 89.7522 118.514 90.5449 116.384 92.5244C120.29 92.2157 123.094 91.9762 125.428 96.1484Z",
    fill: "#E75F5F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.428 96.1484C124.725 97.0855 119.914 98.592 114.582 95.6839C112.428 94.0677 110.07 92.5101 109.611 89.8676C114.54 89.7522 118.514 90.5449 116.384 92.5244C120.29 92.2157 123.094 91.9762 125.428 96.1484Z",
    fill: "#E75F5F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.428 96.1484C124.725 97.0855 119.914 98.592 114.582 95.6839C112.428 94.0677 110.07 92.5101 109.611 89.8676C114.54 89.7522 118.514 90.5449 116.384 92.5244C120.29 92.2157 123.094 91.9762 125.428 96.1484Z",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.699 66.4167C138.161 69.0728 136.435 71.5864 133.851 72.036C131.266 72.4857 128.793 70.7031 128.331 68.047C127.868 65.3909 129.594 62.8773 132.179 62.4276C134.763 61.978 137.237 63.7606 137.699 66.4167Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.476 66.234C114.135 70.3807 112.538 71.1667 116.529 77.0306C111.097 74.2635 108.693 68.9776 119.476 66.234Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.255 78.3004L105.662 80.3922C109.639 85.1598 118.408 89.2636 126.773 88.2405C126.773 88.2393 119.735 93.3017 109.097 85.5013L105.662 80.3922C105.088 79.7043 104.614 79.0025 104.255 78.3004Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.255 78.3004L109.097 85.5013C119.735 93.3017 126.773 88.2393 126.773 88.2405C117.201 89.4112 107.099 83.8688 104.255 78.3004Z",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.264 51.2607C110.826 44.9794 107.105 50.1879 106.968 49.6899C106.83 49.192 113.224 39.2931 119.264 51.2607Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M134.561 57.6243C144.813 59.98 143.257 66.1889 143.726 65.9711C144.194 65.7533 147.589 54.4684 134.561 57.6243Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.818,
    y: 193.513,
    width: 31.9404,
    height: 15.3607,
    transform: "rotate(56.3721 167.818 193.513)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.993 213.789C158.267 223.118 163.514 235.584 163.514 235.584L186.132 220.295C186.132 220.295 176.887 204.051 166.993 213.789Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0752,
    y: 207.504,
    width: 31.9404,
    height: 15.3607,
    transform: "rotate(123.443 88.0752 207.504)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.24382
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0761 214.64C57.0846 210.239 47.648 219.927 47.648 219.927L70.5408 234.802C70.5408 234.802 81.8996 219.959 69.0761 214.64Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.619,
    cy: 86.716,
    rx: 15.2387,
    ry: 15.3607,
    transform: "rotate(-9.87159 152.619 86.716)",
    fill: "#F8973D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3513 53.6487C81.3513 61.4017 75.119 67.6684 67.4536 67.6684C59.7881 67.6684 53.5559 61.4017 53.5559 53.6487C53.5559 45.8958 59.7881 39.6291 67.4536 39.6291C75.119 39.6291 81.3513 45.8958 81.3513 53.6487Z",
    fill: "#F8973D",
    stroke: "black",
    strokeWidth: 2.68202
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M129.504 132.891C129.504 140.71 123.219 147.032 115.485 147.032C107.751 147.032 101.465 140.71 101.465 132.891C101.465 125.072 107.751 118.749 115.485 118.749C123.219 118.749 129.504 125.072 129.504 132.891Z",
    fill: "#F8973D",
    stroke: "black",
    strokeWidth: 2.4382
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 131.913C114.387 139.733 108.101 146.055 100.368 146.055C92.634 146.055 86.348 139.733 86.348 131.913C86.348 124.094 92.634 117.772 100.368 117.772C108.101 117.772 114.387 124.094 114.387 131.913Z",
    fill: "#F8973D",
    stroke: "black",
    strokeWidth: 2.4382
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_3686)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.9751,
    cy: 131.571,
    rx: 15.2387,
    ry: 15.3607,
    fill: "#F8973D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9947 131.571C98.9947 139.39 92.7088 145.712 84.9751 145.712C77.2414 145.712 70.9554 139.39 70.9554 131.571C70.9554 123.751 77.2414 117.429 84.9751 117.429C92.7088 117.429 98.9947 123.751 98.9947 131.571Z",
    stroke: "black",
    strokeWidth: 2.4382
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4972 133.766L129.647 136.77C131.93 136.89 133.339 139.315 132.313 141.358L127.827 150.289C124.606 156.7 117.881 160.583 110.718 160.167L89.6563 158.943C83.1238 158.564 77.3133 154.665 74.4858 148.764L69.4724 138.301C68.4327 136.131 70.0946 133.639 72.4972 133.766Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4382
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_3686",
    x: 68.761,
    y: 116.21,
    width: 32.4271,
    height: 32.6722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.975279
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.48764
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_3686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_3686",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72bc65c5282607c1a0842852ad566f17.svg";
export { ForwardRef as ReactComponent };